import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Landmark, Factory, Hotel, Building, Home } from 'lucide-react';
import { strategicOpportunities } from '../data/mock';

export const StrategicOpportunities = () => {
  const iconMap = {
    'Renewable Energy': Factory,
    'Digital Infrastructure': Landmark,
    'Hospitality': Hotel,
    'Real Estate': Building
  };

  return (
    <div className="service-detail-page">
      {/* Breadcrumb */}
      <div className="breadcrumb-container">
        <Link to="/" className="breadcrumb-link">
          <ArrowLeft size={18} />
          Back to Home
        </Link>
        <span className="breadcrumb-separator">/</span>
        <span className="breadcrumb-current">Strategic Opportunities</span>
      </div>

      {/* Hero Section */}
      <section className="service-detail-hero">
        <h1 className="service-detail-title">Strategic Opportunities</h1>
        <p className="service-detail-subtitle">
          Curated investment and development opportunities for institutional investors, developers and UHNIs
        </p>
      </section>

      {/* Opportunities Grid */}
      <section className="service-detail-section">
        <div className="service-detail-content">
          <div className="opportunities-grid">
            {strategicOpportunities.map((opportunity) => {
              const IconComponent = iconMap[opportunity.sector] || Home;
              return (
                <div key={opportunity.id} className="opportunity-card">
                  <div className="opportunity-icon">
                    <IconComponent size={32} />
                  </div>
                  <div className="opportunity-sector">{opportunity.sector}</div>
                  <h3 className="opportunity-title">{opportunity.title}</h3>
                  <p className="opportunity-description">{opportunity.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Investment Registration CTA */}
      <section className="service-detail-section alt-bg">
        <div className="service-detail-content">
          <div className="investor-registration-cta">
            <h2 className="registration-cta-title">Investor Network Registration</h2>
            <p className="registration-cta-text">
              Register to receive curated opportunities, joint venture proposals and strategic investment mandates directly.
            </p>
            <Link to="/investor-network" className="btn-primary btn-large">
              Register as Investor
            </Link>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="service-detail-section">
        <div className="service-detail-content">
          <div className="service-cta-box">
            <h2 className="cta-title">Explore Investment Opportunities</h2>
            <p className="cta-text">
              Connect with our advisory team to discuss specific opportunities and mandate requirements.
            </p>
            <Link to="/#contact" className="btn-primary">
              Schedule Discussion
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};
